import { render } from "./EprescriptionLayout.vue?vue&type=template&id=0b546a5e&lang=true"
import script from "./EprescriptionLayout.vue?vue&type=script&lang=js"
export * from "./EprescriptionLayout.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__